// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__33gsa","signatureButtonsRight":"ModalSign_signatureButtonsRight__2S3Ns"};